export function PenFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.701 3.279a3 3 0 114.76 3.653l-.932 1.215L14.6 5.2a1 1 0 00-1.2 1.6l3.911 2.933-6.351 8.278a3.001 3.001 0 01-3.252 1.045L7 20h12a1 1 0 110 2H5a1 1 0 01-.793-1.609l1.89-2.52a3.001 3.001 0 01.102-3.512l6.373-8.305L11.7 5.4 9.3 8.6a1 1 0 11-1.6-1.2l2.997-3.996.003-.004a1 1 0 011.4-.2l.002.001 1.688 1.266.911-1.188z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
